<fd-dynamic-page size="large" ariaLabel="Login page" [autoResponsive]="false">

  <!--    'header' is now required for fd-dynamic-page-->
  <fd-dynamic-page-header style="display: none"></fd-dynamic-page-header>

  <fd-dynamic-page-content class="page-content">
    <div class="login-background">

    </div>
    <div class="center-wrap">
      <div class="login-wrap">
        <div class="atom-logo"></div>
        <h3 class="app-title">Unified Services Workspace</h3>
        @if (isAutoLogging) {
          <div class="login-text">
            Logging you in, please wait...
          </div>
          <div class="loading-spinner">
            <fd-busy-indicator [loading]="true" [size]="'m'"></fd-busy-indicator>
          </div>
        }
        @if (!isAutoLogging && !error) {
          <div class="login-text">
            Choose your login option:
          </div>
        }
        @if (!isAutoLogging && !!error) {
          <div class="login-text">
            Sorry, you don't have permission to access the Unified Services Workspace tool on this landscape.
          </div>
        }
        @if (!isAutoLogging) {
          <div class="login-dropdown">
            <fd-select
              class="fd-select"
              [(value)]="selectedProvider"
              >
              <fd-option value="sap.ids">SAP ID Service</fd-option>
              @if (!hideOpscurity) {
                <fd-option value="sap.opscurity">Opscurity IdP</fd-option>
                <fd-option value="sap.opscurity-dev">Opscurity-Dev IdP </fd-option>
              }
              <fd-option value="custom.idp">Custom OIDC Provider</fd-option>
            </fd-select>
          </div>
        }
        @if (!isAutoLogging && !error && infoTextMap[selectedProvider]) {
          <div class="login-info-text">
            {{ infoTextMap[selectedProvider] || '\u00A0' }}
          </div>
        }

        @if (!isAutoLogging && !error) {
          <div>
            <button
              class="uppercase-btn login-button"
              fd-button
              fdType="emphasized"
              (click)="loginByIdp(selectedProvider)"
              >
              {{ selectedProvider === 'custom.idp' ? 'Continue' : 'Log in' }}
            </button>
          </div>
        }
      </div>
    </div>
  </fd-dynamic-page-content>
</fd-dynamic-page>
